import { Bot, Smartphone, Globe, Workflow, PlugZap, MessageCircleCode } from "lucide-react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { wait } from "../../utils/wait";

export const listClients = async () => {
    await wait(500);
    return [
        { 
            id: "comoquieras", 
            name: "ComoQuieras", 
            short: "CQ", 
            logo: "https://admin.comoquieras.com.ar/wp-content/uploads/2026/02/image-06417bac-5bc3-49ba-a366-343aa45b01e5-e1747607030150.jpg", 
            href: "https://comoquieras.com.ar" 
        },
    ];
}

export const listServices = async () => {
    await wait(500);
    return [
        {
            id: "agents",
            title: "AI Agents",
            tag: "AI",
            desc:
                "Agentes autónomos que ejecutan tareas, toman decisiones y usan tus herramientas con control y métricas.",
            icon: <Bot className="w-6 h-6" />,
            bullets: ["Orquestación multi‑tool", "Memoria y contexto", "Guardrails y evaluación"],
        },
        {
            id: "mcps",
            title: "MCP Servers",
            tag: "AI",
            desc:
                "Conectamos LLMs con tus sistemas vía MCP para crear tools seguras y reutilizables.",
            icon: <PlugZap className="w-6 h-6" />,
            bullets: ["Catálogo de tools", "Permisos y auditoría", "Versionado e integración"],
        },
        {
            id: "chatbots",
            title: "ChatBots",
            tag: "AI",
            desc:
                "Asistentes para soporte, ventas y operaciones con RAG y hand‑off humano.",
            icon: <MessageCircleCode className="w-6 h-6" />,
            bullets: ["Web/WhatsApp/Slack", "RAG con tus datos", "Derivación a humanos"],
        },
        {
            id: "n8n",
            title: "Automatización n8n",
            tag: "AI Ops",
            desc:
                "Flujos conectados a tu stack con n8n + LLMs para acelerar procesos críticos.",
            icon: <Workflow className="w-6 h-6" />,
            bullets: ["Integraciones rápidas", "Aprobaciones humanas", "Trazabilidad end‑to‑end"],
        },
        {
            id: "web",
            title: "Desarrollo Web",
            tag: "Product",
            desc:
                "Sitios y apps con React/Next.js y APIs robustas. Performance, SEO y accesibilidad first-class.",
            icon: <Globe className="w-6 h-6" />,
            bullets: ["Landing y ecommerce", "SSR/SSG con Next.js", "Integraciones de pago"],
        },
        {
            id: "mobile",
            title: "Apps Mobile",
            tag: "Product",
            desc:
                "React Native para iOS y Android. Experiencias nativas, rápidas y mantenibles.",
            icon: <Smartphone className="w-6 h-6" />,
            bullets: ["Publicación Store", "Notificaciones push", "CI/CD y testing"],
        },
    ];
}

export const listTeam = async () => {
    await wait(300);
    return [
        { id: "emanuel", name: "Emanuel Cortez", role: "Founder · Full‑Stack / IA", initials: "EC" },
    ];
}

export const chatAuth = async (token: string): Promise<{ success: boolean, access_token: string }> => {
    const response = await axios.post(`${API_BASE_URL}/chat/auth`,
        {},
        {
            headers: {
                'cf-turnstile-token': token
            }
        }
    )

    return response.data;
}

export const chat = async (query: string): Promise<{ content: string, success: boolean, message: string, error: null | any }> => {

    const accessToken = sessionStorage.getItem("chat_token");

    if (!accessToken) {
        return {
            content: "",
            success: false,
            message: "Error",
            error: "Error Chat"
        }
    }

    const body = { query };

    const response = await axios.post(`${API_BASE_URL}/chat/`,
        body,
        {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }
    )

    return response.data;
};